import type React from 'react'
import { Departments } from '@/components/Departments'
import { Subdepartments } from '@/components/Subdepartments'
import { CatalogOfferPage } from '@/pages/CatalogOfferPage'
import { ProductsPage } from '@/pages/ProductsPage'
import { QuickSearchResultsPage } from '@/pages/QuickSearchResultsPage'
import { SeasonSelectionPage } from '@/pages/SeasonSelectionPage/SeasonSelectionPage'

export interface AppRouteProps {
  Component: React.ComponentType
  path: string
}

export const NON_SEASON_ROUTES: AppRouteProps[] = [
  { path: '/', Component: SeasonSelectionPage },
]

export const SEASON_ROUTES: AppRouteProps[] = [
  { path: '/:season', Component: CatalogOfferPage },
  { path: '/:season/universe/:universeId', Component: Departments },
  { path: '/:season/universe/:universeId/department/:departmentId', Component: Subdepartments },
  { path: '/:season/universe/:universeId/department/:departmentId/subdepartment/:subdepartmentId/families', Component: ProductsPage },
  { path: '/:season/universe/:universeId/department/:departmentId/subdepartment/:subdepartmentId/full/families', Component: ProductsPage },
  { path: '/:season/universe/:universeId/department/:departmentId/subdepartments/families', Component: ProductsPage },
  { path: '/:season/universe/:universeId/department/:departmentId/all-families', Component: ProductsPage },
  { path: '/:season/search', Component: QuickSearchResultsPage },
]

const ROUTES: AppRouteProps[] = [...NON_SEASON_ROUTES, ...SEASON_ROUTES]
export default ROUTES
